export default __webpack_public_path__ + "static/media/Group 2138.959913bc.svg";